module.exports = __webpack_public_path__ + "img/avatar2.bab4e43d.png";